import { render, staticRenderFns } from "./TaskTypesDropdown.vue?vue&type=template&id=2581edab&"
import script from "./TaskTypesDropdown.vue?vue&type=script&lang=ts&"
export * from "./TaskTypesDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports